export const TOOLTIP_POSITION = {
  TOP: 'top',
  TOP_START: 'top-start',
  TOP_END: 'top-end',
  BOTTOM: 'bottom',
  BOTTOM_START: 'bottom-start',
  BOTTOM_END: 'bottom-end',
  LEFT: 'left',
  LEFT_START: 'left-start',
  LEFT_END: 'left-end',
  RIGHT: 'right',
  RIGHT_START: 'right-start',
  RIGHT_END: 'right-end',
} as const;

export type TooltipPosition =
  (typeof TOOLTIP_POSITION)[keyof typeof TOOLTIP_POSITION];

export const TOOLTIP_VARIANT = {
  BLACK: 'black',
  WHITE: 'white',
} as const;

export type TooltipVariant =
  (typeof TOOLTIP_VARIANT)[keyof typeof TOOLTIP_VARIANT];
